module.exports = __webpack_public_path__ + "static/media/tests.964ee7e6.svg";